import { render, staticRenderFns } from "./VersionForm.vue?vue&type=template&id=7a5c697c&scoped=true&"
import script from "./VersionForm.vue?vue&type=script&lang=js&"
export * from "./VersionForm.vue?vue&type=script&lang=js&"
import style0 from "./VersionForm.vue?vue&type=style&index=0&id=7a5c697c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5c697c",
  null
  
)

export default component.exports